// extracted by mini-css-extract-plugin
module.exports = {"also-read-wrapper":"ykszE","also-read-text":"MeaEn","also-read-left":"_2ok_6","also-read-right":"UEAwc","also-read-link":"_1cNC1"};